
import { Insta } from "../../src/components/insta/InstaClass";
import { Phone, PHONE_BUTTONS } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import UI from "../../src/shell/UI";
import { jump } from "../../src/shell/jump";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { pcLady } from "../characters/PCLady";
import { vanessa } from "../characters/Vanessa";
import { getAlexImagesPost } from "../helpers/alexInstaHelpers";
import { checkCurrentImage, doWaitImageByTime, getInstaImage } from "../helpers/helpers";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { images, uiImages } from "./images";
import { v1AnnBarMeeting } from "./V1_AnnBarDate";
import { v1VanessaBarMeeting } from "./V1_VanessaBarDate";
import { AfterBarAtHome } from "./V2";
import { AfterClubSMSFromVanessasPhone } from "./V4";
import { V8UnexpectedNTRQuestion } from "./V8";
import { TODWatchingVanessaJoe } from "./V2.5";
import SoundClass from "../../src/shell/Sound";
import { sounds } from "./sounds";


// export const globals = (gameObject: GameObject): GameObject => {
//     const _ann = gameObject.characters?.[ann.key];
//     if (_ann?.properties?.corruption >= 9) {

//         (_ann.properties as AnnPropertiesINT).isCorrupted = true;
//     }


//     return gameObject;
// };
export const testClickable = async (): Promise<any> => {
    mc.talk(`testClickable`);
    await UI.addClickableItem({
        key: "testPc",
        mainImage: images.v1.testpc1,
        clickableImages: [
            {
                image: images.v1.testpc1.partials.testpc3,
                highlightImage: images.v1.testpc1.partials.testpc2,
                key: "pc2"
            },
        ]
    });


    if (UI._globalUI.testPc === "pc2") {
        mc.talk(`CLICKED PC`);
    }


    mc.talk(`after clicked`);
    ImageClass.setImage(images.v1.Room1);
    mc.talk(`before jumping`);
    return jump(testClickable, "testClickable");
};


export const start = async () => {

    ImageClass.setImage(images.v1.Room1);
    // SoundClass.startSound(sounds.keyboard_typing, { shouldPlay: true, loop: true });
    mc.talk("That's about it, I told you everything.\nNow I need your advice.", { method: "On Chat" });


    // TODO: remove
    // return jump(testClickable, "testClickable");
    // return jump(TODWatchingVanessaJoe, "TODWatchingVanessaJoe");
    // ImageClass.setImage(images.v8.test1);

    // mc.think(`Nice legs!`);
    // ImageClass.setAnimation(images.v1.Anim_JoeVanBedLegs, { loop: 0, wait: true, duration: 0 });
    // TODO: delete
    // ImageClass.setAnimations([
    //     { ...images.v8.Anim_EmilyExSex, options: { loop: 1 } },
    //     // { ...images.v8.Anim_EmilyExSexPartial, options: { loop: 0 } },
    // ]);
    // ImageClass.setAnimations([
    //     { ...images.v8.Anim_AnnDormMasturbateUpDown, options: { loop: 1 } },
    //     { ...images.v8.Anim_AnnDormReadyToMasturbateFast, options: { loop: 1 } },
    //     { ...images.v8.Anim_AnnMasturbateFast, options: { loop: [3, 5] } },
    //     { ...images.v8.Anim_AnnDormInsertFingers, options: { loop: 1 } },
    //     { ...images.v8.Anim_AnnDormMasturbateWithFingers, options: { loop: [2, 5] } },
    //     { ...images.v8.Anim_ResetMasturbatePose, options: { loop: 1 } },
    // ]);
    pcLady.talk("Wow, that's a lot...", { method: "Over Chat" });
    pcLady.talk("I wonder what would have happened if Ann hadn't introduced you to Vanessa.", { method: "Over Chat" });
    mc.talk("It's the other way around, Vanessa introduced me to Ann!", { method: "On Chat" });
    // // TODO: delete this
    // pcLady.talk("I wonder what would have happened if Ann hadn't introduced you to Vanessa.", { method: "Over Chat" });
    // ImageClass.setImage(images.v1.Room1);
    // mc.talk("That's about it, I told you everything.\nNow I need your advice.", { method: "On Chat" });

    pcLady.talk("What? Are you sure?", { method: "Over Chat" });
    pcLady.talk("Besides, it's all too hard to believe, I've seen your picture, you look good and fit. No way you acted like you told me.", { method: "Over Chat" });
    mc.talk("I wasn't always like that. Weren't you reading??", { method: "On Chat" });
    pcLady.talk("I did. But there are a lot of missing pieces.", { method: "Over Chat" });
    pcLady.talk("I think you should just start from the beginning. This time, don't leave out any details.", { method: "Over Chat" });
    mc.talk("Ok.\nSo it all started when I was born and my mother named me...", { method: "On Chat" });
    const name = await Game.showInput({ text: "Enter your name.", placeholder: "Ben", key: "enterName" });
    if (name) {
        await mc.set((properties) => {
            mc.name = name;
        });
    }
    mc.talk(`Ok.\nSo it all started when I was born and my mother named me ${mc.name}.`, { method: "On Chat" });
    pcLady.talk("LOL! You can speed it up!\nStart after you graduated.", { method: "Over Chat" });
    mc.talk("Haha, I was joking. I'll start from the interesting part, but this time try to follow.", { method: "On Chat" });
    pcLady.talk("Oh wait! Before you start, there is something really important I gotta ask you.", { method: "Over Chat" });
    mc.talk("Sure, what is it?", { method: "On Chat" });
    return jump(v1NTRQuestion, "v1NTRQuestion");
};

export const v1NTRQuestion = async () => {
    ImageClass.setImage(images.v1.Room1);

    await pcLady.setQuestion(new Question({ text: 'I was wondering, how do you feel about NTR?', key: "v1EnableNTR" })
        .option({ title: `I don't mind it (Enable NTR)`, key: true })
        .option({ title: `I hate it (Disable NTR)`, key: false }));

    if (Question.globalAnswers.v1EnableNTR) {
        mc.talk("I don't mind it.", { method: "On Chat" });
        await V8UnexpectedNTRQuestion();

    } else {
        mc.talk("I hate it.", { method: "On Chat" });

    }

    mc.talk(`But why is that important right now?`, { method: "On Chat" });
    pcLady.talk(`Damage control.`, { method: "Over Chat" });
    mc.talk(`I don't follow.`, { method: "On Chat" });
    pcLady.talk(`It's not important.`, { method: "Over Chat" });
    pcLady.talk(`Anyway, now I am all ears... Or eyes.`, { method: "Over Chat" });
    mc.talk(`Ok...`, { method: "On Chat" });
    mc.talk(`So it all started that summer after I graduated.`, { method: "On Chat" });
    mc.talk(`I remember waking up on the first day of vacation...`, { method: "On Chat" });

    // SoundClass.stopSound(sounds.keyboard_typing);

    ImageClass.setImage(images.v1.Room2);
    mc.talk(`Finally! Spring break is here! Now I have all the time in the world to level up my mage in World of Warcraft.`);
    mc.talk(`I'll just stay in bed for a few more minutes, it's not like anyone is going to wake me up...\nMy parents are always on a business trip and I have the house all to myself.`);
    mc.talk(`My phone is ringing.`);
    ImageClass.setImage(images.v1.JoeyCallBed);
    mc.talk(`Me and my big mouth...`);
    ImageClass.setImage(images.v1.JoeyCallBed1);
    mc.talk(`Hey Joey! What's up?`);
    joe.talk(`Hey ${mc.name} how are you enjoying the first day of spring break?`);
    mc.talk(`Well, to be honest, I am still in bed. Still waking up. Give me a few minutes, and let's party up and level our mages together!`);
    joe.talk(`You know I always enjoy playing with you but there is something I wanted to talk to you about.`);
    mc.talk(`What is it man?`);
    joe.talk(`It's better if we talk in person. Can I come over?`);
    mc.talk(`Sure, if you don't mind me being a zombie for a few minutes until I wake up.`);
    joe.talk(`On my way.`);
    ImageClass.setImage(images.v1.Room2);
    mc.talk(`I wonder what's up with him, he has been playing less lately, maybe he found a new game? No, no way he would come over just to tell me that.`);
    mc.talk(`Anyway, he lives pretty close so he should be here any minute now.`);
    ImageClass.setImage(images.v1.RoomAlone_2);
    mc.talk(`It was even faster than I thought; he is knocking on my door.`);



    ImageClass.setImage(images.v1.RoomFatJoey1);
    mc.talk(`There he was, my best friend, overweight young adult, kinda clumsy but always positive and smiling.`);

    joe.talk(`Hey ${mc.name}, I hope you don't mind me using that spare key to get into your house.`);
    mc.talk(`No, not at all, you know you're always welcome here and that way I don't have to get up to open the door.`);
    mc.talk(`Come in and tell me what's on your mind.`);
    ImageClass.setImage(images.v1.RoomFatJoey3);
    joe.talk(`Ok, so I'll get right to the point.`);
    joe.talk(`It's been on my mind a lot lately...\nYou know I like playing with you online and all of that, but I think we should start doing some other stuff.`);
    joe.talk(`We should go out, meet some girls!\nI even signed up to the gym, it's time for me to lose some weight, I'm sick of being the fat kid.`);
    ImageClass.setImage(images.v1.RoomFatJoey2);
    joe.talk(`Look at me! I look like Professor Sherman in that Eddie Murphy movie.`);
    joe.talk(`So... I was thinking that instead of playing we can go out and see the world...\nWhat do you think?`);
    mc.talk(`I'd rather stay at home for now... We have plenty of time to do all of those outside activities in the future.`);

    await mc.setQuestion(new Question({ text: 'And I think that you signed up for the gym is a...', key: "v1Gym" })
        .option({ title: `Great idea`, key: 'great idea' })
        .option({ title: `Bad idea`, key: 'bad idea' }));

    if (Question.globalAnswers.v1Gym === "great idea") {
        ImageClass.setImage(images.v1.RoomFatJoeyHappy);
        mc.talk(`Great idea!`);
        mc.talk(`It's great that you found the motivation to go to the gym and change your life. I'm happy for you dude.`);
        joe.talk(`Thanks man! It means a lot to me.`);
    } else {
        mc.talk(`Bad idea! We have all the time in the world for that stuff. Right now is time to level up our characters in World of Warcraft! Why now? We can always meet chicks online!`);
        ImageClass.setImage(images.v1.RoomFatJoeySad);
        joe.talk(`That's just not the same. I've already made up my mind, I was just hoping you would do this with me.`);
        mc.talk(`Maybe later, dude.`);
    }


    ImageClass.setImage(images.v1.RoomFatJoey3);
    joe.talk(`I just hope we'll still be best friends, even when we don't play together as much.`);
    mc.talk(`You bet we will! You're just going to the gym, it's not like you're moving to a different country.`);
    ImageClass.setImage(images.v1.RoomFatJoey2);
    joe.talk(`Yeah I guess.`);
    joe.talk(`I should get going now, I have my first appointment with a personal trainer at the gym soon.\nI'll talk to you later!`);
    mc.talk(`Bye Joey.`);
    ImageClass.setImage(images.v1.RoomAlone_2);
    mc.think(`Joey and I have been best friends since we were kids, I bet he will go to the gym for a few weeks and then will get sick of it.`);
    mc.think(`And I know he wanted to meet girls for a long time now, me too, but I am sure I'll meet someone if I want it or not.`);
    mc.think(`Anyways... I guess I'm playing alone today.`);

    ImageClass.setImage(images.v1.Room1);
    mc.talk(`So just like that, Joey left, and started his adventure.`);
    pcLady.talk(`Why didn't you join him?`, { method: "Over Chat" });
    mc.talk(`My mind was in a different place at that point.`);
    pcLady.talk(`Yeah, the mage.`, { method: "Over Chat" });
    mc.talk(`Yeah...`);
    mc.talk(`I felt like I had all the time in the world, and it was the first time that I was actually free to do what I wanted when I wanted.\nSo I didn't feel like I was in a rush.`);
    pcLady.talk(`Ok, keep going.`, { method: "Over Chat" });
    mc.talk(`So after a year I was still doing my usual routine, playing online games all night, waking up late, nothing special.`);
    mc.talk(`But then I got a call...`);

    ImageClass.setImage(images.v1.Room2);

    mc.think(`I can't believe it's been a year since I finished school already, and I'm still sitting at home doing nothing other than playing this stupid game.`);
    mc.think(`I know I should really get out of the house, find a job and start doing something with my life, but it's so easy to just stay at home since my parents are always away.`);
    mc.think(`No one tells me what to do so there is no rush.`);

    ImageClass.setImage(images.v1.JoeyCallBed);

    mc.think(`Joey?? I haven't heard from him in so long. I bet he wants some power leveling since I'm almost maxed out with my mage.`);

    ImageClass.setImage(images.v1.JoeyCallBed1);
    mc.talk(`JOEY! It's been forever, how you doin'?`, { method: "On Phone" });
    joe.talk(`Hey ${mc.name}, long time no see! I'm doing real good.\nWhat's up with you?`, { method: "Over Phone" });
    mc.talk(`Well, remember everything I did a year ago?`, { method: "On Phone" });
    joe.talk(`Yeah.`, { method: "Over Phone" });
    mc.talk(`So I am still doing that.`, { method: "On Phone" });
    joe.talk(`Aren't you tired of that game already? I remember it being grindy as hell.`, { method: "Over Phone" });
    mc.talk(`You know, if I'm being completely honest, lately I was thinking about doing some boring adult stuff, like getting a real job.`, { method: "On Phone" });
    joe.talk(`I guess I called at the perfect time!\nListen, the past year has been amazing, you won't believe the things I've been up to.`, { method: "Over Phone" });
    mc.talk(`Like what?`, { method: "On Phone" });
    joe.talk(`Can I come over maybe? It'll be easier to explain in person.`, { method: "Over Phone" });
    mc.talk(`Sure man.`, { method: "On Phone" });
    joe.talk(`Ok, on my way. Do you want me to use my key or knock?`, { method: "Over Phone" });
    mc.talk(`The key of course, just because we haven't talked for a long time, doesn't mean you've lost your burglary privileges.`, { method: "On Phone" });
    joe.talk(`Haha, it's not burglary if I'm using a key that YOU gave me!`, { method: "Over Phone" });
    mc.talk(`Haha, I was just joking.`, { method: "On Phone" });
    joe.talk(`I'll be right there.`, { method: "Over Phone" });


    ImageClass.setImage(images.v1.Room1);
    mc.talk(`That call was the start of a chain of events that made me who I am today.`);
    mc.talk(`So after a few minutes Joey was knocking at my door.`);
    pcLady.talk(`And what did you see??`, { method: "Over Chat" });
    mc.talk(`You know, what we talked about just before.`);
    pcLady.talk(`I know, but I'm trying to add some tension to the atmosphere, who knows who is listening.`, { method: "Over Chat" });
    mc.talk(`Right. Haha.`);
    mc.talk(`So I opened the door, and Joey was standing there, but not the Joey I knew. He was different.`);
    mc.talk(`He got a haircut.`);

    ImageClass.setImage(images.v1.ThinJoey1);
    mc.think(`Joey suddenly became half the man I used to know, literally.`);
    joe.talk(`Hey ${mc.name}.`);
    mc.talk(`What the fuck?? Joey??`);
    joe.talk(`Yeah it's me! I knew you'd be surprised. That's why I said it would be easier to explain in person.\nAnd it's Joe now. I dropped the Y along with my weight. Haha.`);
    mc.talk(`I can't believe it! You look like a whole new person, you even shaved your head! If it wasn't for the clothes, I wouldn't have even recognized you.`);
    joe.talk(`That's the one thing I couldn't give up on.`);
    mc.talk(`Come in and tell me everything!`);
    ImageClass.setImage(images.v1.ThinJoey2);
    joe.talk(`Thanks. Haha.`);
    ImageClass.setImage(images.v1.ThinJoey3);
    mc.talk(`Damn! This is gonna take some getting used to.`);
    ImageClass.setImage(images.v1.ThinJoey4);
    joe.talk(`Yeah I figured.`);
    joe.talk(`Ok, so there is a lot to tell, but I'll try to make a long story short.`);
    joe.talk(`Like I was saying on the phone, the past year has been crazy! At first I started working out at the gym, nothing special.`);
    joe.talk(`I even thought about quitting a few times.\nBut the more I kept going the more I kept getting positive feedback from girls. They started smiling and flirting with me.`);

    await joe.setQuestion(new Question({ text: 'I got addicted to that feeling. Before I felt like I was invisible to girls. Not anymore!', key: `v1JoeFirstQuestion` })
        .option({ title: `Have you fucked someone...`, key: 'fuckedSomeone' })
        .option({ title: `Do you have a girlfriend?`, key: 'haveGF' }));


    if (Question.globalAnswers.v1JoeFirstQuestion === "fuckedSomeone") {
        ImageClass.setImage(images.v1.ThinJoey3);
        mc.talk(`Have you fucked someone already?`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`Haha, to tell you the truth, I lost count on how many I scored with.`);
        ImageClass.setImage(images.v1.ThinJoey2);
        joe.talk(`So yeah, I am all good in that department.`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`There is this girl I am seeing right now.`);
    } else {
        ImageClass.setImage(images.v1.ThinJoey3);
        mc.talk(`Do you have a girlfriend?`);
        ImageClass.setImage(images.v1.ThinJoey2);
        joe.talk(`I don't like the term girlfriend, but yes, I have a girl that I meet up with the most.`);
    }


    ImageClass.setImage(images.v1.ThinJoey4);

    await joe.setQuestion(new Question({ text: 'We were supposed to hang out right about now. She should be at my house right now. Do you want to meet her? I can tell her to come over.', key: `V1invitedVanessa` })
        .option({ title: `Invite her`, key: true })
        .option({ title: `Don't invite her`, key: false }));

    if (Question.globalAnswers.V1invitedVanessa) {

        mc.talk(`Sure, you can invite her here.`);
        ImageClass.setImage(images.v1.ThinJoey2);
        joe.talk(`Great! I'll just go and bring her back here.`);
    } else {
        ImageClass.setImage(images.v1.ThinJoey3);
        mc.talk(`No, I'd rather not.`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`Ok bro, if you want to hang out sometime, just give me a call.`);
        mc.talk(`Will do!`);
    }

    ImageClass.setImage(images.v1.RoomAlone_2);

    mc.talk(`I can't believe how much he's changed in a such small period of time.`);
    mc.talk(`I should go out with him more, he seems to know what's up.`);

    if (Question.globalAnswers.V1invitedVanessa) {
        return jump(v1VanessaVisit, "v1VanessaVisit");
    }
    return jump(v1VanessaDontVisit, "v1VanessaDontVisit");
};

export const v1VanessaVisit = async () => {
    ImageClass.setImage(images.v1.RoomAlone_2);
    mc.think(`That must be them knocking at the door.`);

    ImageClass.setImage(images.v1.JoeVenDoor);
    joe.talk(`Hey ${mc.name}, meet Vanessa.`);

    mc.talk(`Hey! It's nice to meet you!`);
    await mc.set((properties) => {
        properties.metVanessa = true;
    });
    vanessa.talk(`Hey, are you going to invite me in?`);
    ImageClass.setImage(images.v1.JoeVenDoor.partials.JoeVenDor_Vunsure);
    mc.talk(`Yes, yes, of course come in.`);
    ImageClass.setImage(images.v1.JoeVenDoor);
    vanessa.talk(`Don't take me too seriously, I was just joking.`);
    doWaitImageByTime(images.v1.JoeVanBed0);
    mc.think(`She's hot, who would've thought Joey could get a girl like that.`);
    ImageClass.setImage(images.v1.Anim_JoeVanBedLegs.poster);
    mc.think(`Nice legs!`);
    ImageClass.setAnimation(images.v1.Anim_JoeVanBedLegs, { loop: 0, wait: true, duration: 0 });
    mc.think(`Oh shit! Did she see me looking?`);
    ImageClass.setImage({ ...images.v1.JoeVenBed1, partialsToDisplay: [images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk] });
    vanessa.talk(`${mc.name}, I've heard so much about you, it's so nice to finally meet you.`);
    mc.talk(`Joey and I haven't been in touch for a long time. I just found out about you.`);
    vanessa.talk(`Yeah, I know all about it. Don't worry.`);
    ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VNatural);
    mc.talk(`That's great.\nSo how did you two meet?`);
    ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_JTalk);
    joe.talk(`Vanessa and I need to get going in a few minutes so it's better if we save that story for another time.`);
    joe.talk(`I really just wanted the both of you to meet, that's why I invited her over.`);
    ImageClass.setImage(images.v1.JoeVenBed2);
    joe.talk(`But let's just say she couldn't resist when I hit on her.`);
    ImageClass.setImage(images.v1.JoeVenBed1);
    vanessa.talk(`Something like that haha.`);


    await vanessa.setQuestion(new Question({ text: `${mc.name}, are you seeing anyone right now?`, key: `V1AreYouSeeingAnyone` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.V1AreYouSeeingAnyone) {
        await mc.set((properties) => {
            properties.liar++;
        });
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VNatural);
        mc.talk(`Yes I am.`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_JTalk);
        joe.talk(`Really? You didn't mention her.`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk);
        vanessa.talk(`Oh, that's too bad. I was thinking of introducing you to my friend, I think you guys would get along great.`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VNatural);
        mc.talk(`How old is she anyway?`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk);
        vanessa.talk(`Same as all of us! She is nineteen.`);
        ImageClass.setImage(images.v1.JoeVenBed2);
        joe.talk(`Are you talking about Ann?`);
        vanessa.talk(`Yes! Wouldn't she be perfect for him?`);
        joe.talk(`A bit nerdy for my taste, but why not?`);
        vanessa.talk(`That's why I figured her and ${mc.name} would be good match.`);
        ImageClass.setImage(images.v1.JoeVenBed1);
        mc.talk(`Hey hey, I'm not a nerd.`);

        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk);

        vanessa.talk(`I never said you were. I just figured she would be perfect for you, based on the stories that Joe told me about you.`);
        vanessa.talk(`How about I just give you her number and you can give her a call if you want.`);
    } else {
        await mc.set((properties) => {
            properties.liar--;
        });

        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VNatural);
        mc.talk(`No, I am not seeing anyone.`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk);
        vanessa.talk(`GREAT! I have a friend that will be perfect for you!`);
        ImageClass.setImage(images.v1.JoeVenBed2);
        joe.talk(`Are you talking about Ann?`);
        vanessa.talk(`Yes! Wouldn't she be perfect for him?`);
        mc.talk(`Do you have a picture of her or something?`);
        ImageClass.setImage(images.v1.JoeVenBed1);
        vanessa.talk(`No... I don't.`);

        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VNatural);
        mc.talk(`How come? Don't you have her on Facebook or Insta?`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk);
        vanessa.talk(`She's not the social media type. So no...`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VNatural);
        mc.talk(`How old is she anyway?`);
        ImageClass.setImage(images.v1.JoeVenBed1.partials.JoeVenBed1_VTalk);
        vanessa.talk(`Same as all of us! She is nineteen.`);
        vanessa.talk(`Well ${mc.name}, I'll give you her number and if you want give her a call.`);
    }


    return jump(v1JoeyLeft, "v1JoeyLeft");

};
export const v1VanessaDontVisit = async () => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    mc.think(`Ok I have nothing better to do, so I might just check if there are some new hotties on Insta. `);
    await Insta.open(getInstaData());
    ImageClass.setImage(images.v1.RoomComputerScreenCloseOn);
    await mc.set((properties) => {
        properties.sawAlex = true;
    });
    mc.think(`I've never seen her before! She must be new, only one photo and no comments or likes.`);
    const alexProfile = Insta.instaProfiles?.[alex.name];
    if (alexProfile?.images.find(image => image.key === "alex1")?.mcLiked) {
        mc.think(`She's got my like. I wonder if she will see it.`);

    }
    if (getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}1`)?.mcLiked) {

        mc.think(`She's got my like. I wonder if she will see it.`);
    }

    mc.think(`She really has potential, I bet she will become famous in the future.`);
    mc.think(`Alright, nothing better to do so might as well play some games...`);

    ImageClass.setImage(images.v1.sometimelater);
    ImageClass.setImage(images.v1.RoomAlone_2);
    mc.think(`Someone is knocking on the door.`);
    mc.talk(`It's open!`);
    ImageClass.setImage(images.v1.ThinJoey2);
    joe.talk(`Hey ${mc.name}, sorry for leaving in a hurry earlier, I didn't want to keep my girl's ass waiting, if you know what I mean.`);
    mc.talk(`Yeah I get it... Does she really let you stick it up her ass?`);
    joe.talk(`Of course! She's basically addicted to it by now. But that's not important now.`);
    joe.talk(`Listen, Vanessa has this friend, her name's Ann. She's perfect for you, really cute and shy.`);
    joe.talk(`I asked for her number, I'll text it to you. Give her a call if you have the chance.`);
    mc.talk(`Are you a matchmaker now?`);
    ImageClass.setImage(images.v1.ThinJoey4);
    joe.talk(`Just helping a friend out.\nWhat's wrong with that?`);
    ImageClass.setImage(images.v1.ThinJoey3);
    mc.talk(`Nothing. Maybe I will give her a call.`);
    ImageClass.setImage(images.v1.ThinJoey2);
    joe.talk(`Please do! And don't forget to tell me all about it.`);
    mc.talk(`Of course, I'll update you.`);
    joe.talk(`By the way, since you didn't want to meet Vanessa, I have some pictures of her in my phone.`);
    ImageClass.setImage(images.v1.ShowingPhone);
    joe.talk(`Swipe right, there are a few more pictures of us.`);
    return jump(v1SwipingJoesPhone, "v1SwipingJoesPhone");
};

export const getJoePicByIndex = (index: number): TimageINT & { key: string; } => {
    switch (index) {
        case 0:
        default:
            return images.v1_JoeShowingPics.JoeyShowingPhone1;
        case -1:
            return images.v1_JoeShowingPics.JoeyShowingPhone4;
        case -2:
            return images.v1_JoeShowingPics.JoeyShowingPhone5;
        case -3:
            return images.v1_JoeShowingPics.JoeyShowingPhone6;
        case 1:
            return images.v1_JoeShowingPics.JoeyShowingPhone2;
        case 2:
            return images.v1_JoeShowingPics.JoeyShowingPhone3;
    }

};

export const v1SwipingJoesPhone = async (): Promise<any> => {
    ImageClass.setImage(images.v1.ShowingPhone);
    if (empty.properties.v1JoePhoneCounter == undefined) {
        await empty.set((properties) => {
            properties.v1JoePhoneCounter = 0;
        });
    }
    const image = getJoePicByIndex(empty.properties.v1JoePhoneCounter || 0);
    const phoneBtn = await Phone.open(image, async () => {
        let buttonList = Object.values(PHONE_BUTTONS);
        // most left image
        if (checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone6)) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.LEFT);
        }
        // most right image
        if (checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone3)) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.RIGHT);
        }
        Phone.setButtons(buttonList);

        if (!mc.properties.v1VanessasPhotosSeen.includes(image.key) && checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone6)) {

            Phone.talk({ character: mc.character, text: "Wow Joey, where did you find this girl?", options: { think: true } });
            await mc.set((properties) => {
                properties.v1MCSawVanessasBoobsAss = "boobs";
            });
        } else if (!mc.properties.v1VanessasPhotosSeen.includes(image.key) && checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone5)) {
            Phone.talk({ character: mc.character, text: "Holy shit! Those are definitely not for my eyes...", options: { think: true } });
        } else if (!mc.properties.v1VanessasPhotosSeen.includes(image.key) && checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone4)) {
            await mc.set((properties) => {
                if (properties.v1MCSawVanessasBoobsAss) {
                    properties.v1MCSawVanessasBoobsAss = "both";
                } else {
                    properties.v1MCSawVanessasBoobsAss = "ass";
                }
            });
            Phone.talk({ character: mc.character, text: "Wow... Now I understand why he told me to swipe right... His girl is all out for display.", options: { think: true } });
        } else if (!mc.properties.v1VanessasPhotosSeen.includes(image.key) && checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone1)) {

            Phone.talk({ character: mc.character, text: "I can't say she isn't cute, nice boobs and a hot body.", options: { think: true } });
        } else if (!mc.properties.v1VanessasPhotosSeen.includes(image.key) && checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone2)) {

            Phone.talk({ character: mc.character, text: "They look happy together.", options: { think: true } });
        } else if (!mc.properties.v1VanessasPhotosSeen.includes(image.key) && checkCurrentImage(image, images.v1_JoeShowingPics.JoeyShowingPhone3)) {

            Phone.talk({ character: mc.character, text: "Joey is kissing a hot girl, that's a first.\nI guess he is a player now.", options: { think: true } });
        } else {
            Phone.talk({ character: mc.character, text: "", options: { think: true, wait: false } });
        }



    });
    if (!mc.properties.v1VanessasPhotosSeen.includes(image.key)) {
        await mc.set((properties) => {
            properties.v1VanessasPhotosSeen.push(image.key);
        });
    }
    // Phone.talk({ character: mc.character, text: "", options: { think: true, waitForPress: false } });


    if (phoneBtn === PHONE_BUTTONS.RIGHT) {
        await empty.set((properties) => {
            if (properties.v1JoePhoneCounter! < 2)
                properties.v1JoePhoneCounter!++;
        });
    } else if (phoneBtn === PHONE_BUTTONS.LEFT) {
        await empty.set((properties) => {
            if (properties.v1JoePhoneCounter! > -3) {
                properties.v1JoePhoneCounter!--;
            }
        });
    } else if (phoneBtn === PHONE_BUTTONS.EXIT) {
        Phone.close(false);
        return jump(AfterVanessaVisit, "AfterVanessaVisit");
    }

    return jump(v1SwipingJoesPhone, "v1SwipingJoesPhone");

};
export const AfterVanessaVisit = async (): Promise<any> => {
    ImageClass.setImage(images.v1.ThinJoey4, { duration: 1 });
    await joe.setQuestion(new Question({ text: `Well, what do you think?`, options: { think: false }, key: `v1MCCommentsOnVanessaPhotos` })
        .option({ title: `She's cute`, key: `sheIsCute` })
        .option({ title: `She's hot as hell`, key: `hotAsHell` }));


    if (Question.globalAnswers.v1MCCommentsOnVanessaPhotos === "hotAsHell") {
        ImageClass.setImage(images.v1.ThinJoey3);
        mc.talk(`She's really hot dude, nice job!`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`Well you haven't seen shit!`);
        if (mc.properties.v1MCSawVanessasBoobsAss) {

            mc.think(`He has no idea...`);
        }

        ImageClass.setImage(images.v1.ThinJoey2);
        mc.talk(`Yeah... I guess.`);

    } else {
        ImageClass.setImage(images.v1.ThinJoey3);
        mc.talk(`She's cute.`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`Cute? Have you seen her boobs?`);
        if (mc.properties.v1MCSawVanessasBoobsAss) {

            mc.think(`More than you think.`);
        }
        ImageClass.setImage(images.v1.ThinJoey2);
        mc.talk(`Mmm... I couldn't miss them...`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`It's ok dude I don't mind if you look.`);
        ImageClass.setImage(images.v1.ThinJoey2);
        mc.talk(`She's still your girlfriend... It wouldn't be appropriate.`);
        ImageClass.setImage(images.v1.ThinJoey4);
        joe.talk(`I already told you, not a girlfriend, a GIRL that I am seeing now. Just don't say that when she is around haha.`);
        ImageClass.setImage(images.v1.ThinJoey3);
        mc.talk(`Sure.`);
    }
    mc.talk(`How old is she anyway?`);
    joe.talk(`Same as me, Nineteen.`);
    mc.talk(`Oh nice!`);
    ImageClass.setImage(images.v1.ThinJoey4);
    joe.talk(`Ok dude I'm off, it's getting late.`);
    joe.talk(`Talk to you tomorrow, don't forget to give Ann a call.`);
    return jump(v1JoeyLeft, "v1JoeyLeft");
};

export const v1JoeyLeft = async () => {
    ImageClass.setImage(images.v1.Room1);
    mc.talk(`That was the first time I heard about Ann.`, { method: "On Chat" });
    pcLady.talk(`I must say, it seems like your whole life is waiting in your room for people to knock on your door.`, { method: "Over Chat" });
    mc.talk(`It only seems that way because I'm trying to leave out the boring stuff.`, { method: "On Chat" });
    mc.talk(`I'm sure you don't want to hear about my adventures in my online games.`, { method: "On Chat" });
    pcLady.talk(`I really don't...`, { method: "Over Chat" });
    mc.talk(`Great, so I'll continue.`, { method: "On Chat" });
    mc.talk(`The next day I had to decide whether to call Ann or not.`, { method: "On Chat" });



    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.talk(`Wow, yesterday was so different from any other day I had recently.`);
    mc.talk(`I spoke with Joey after so long and now I have this girl Ann's phone number, without even working for it.`);
    mc.talk(`I know nothing about her except her name and the fact she is cute and shy...`);
    mc.talk(`I could give her a call, or I could always just say fuck that and call Joey.`);

    await mc.setQuestion(new Question({ text: 'Who should I call?', key: `v1FirstCall` })
        .option({ title: `Call Ann`, key: 'ann' })
        .option({ title: `Call Joey`, key: 'joe' }));

    if (Question.globalAnswers.v1FirstCall === "ann") {
        await mc.set((properties) => {
            properties.metAnn = true;
            properties.v1Visited = "ann";
        });
        await v1CalledAnn();
        return jump(v1AnnLibrary, "v1AnnLibrary");

    }
    return jump(v1CalledJoe, "v1CalledJoe");
};

export const v1CalledAnn = async () => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
    mc.think(`What do I have to lose right?`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    ann.talk(`Hello?`, { method: "Over Phone" });
    mc.talk(`Hey, Ann?`, { method: "On Phone" });
    ann.talk(`Yes, who is it?`, { method: "Over Phone" });
    mc.talk(`I am ${mc.name}.`, { method: "On Phone" });
    await ann.setQuestion(new Question({ text: `${mc.name}? I don't know anyone by that name...`, key: `v1AnnFirstCall`, options: { method: "Over Phone" } })
        .option({ title: `Be straight forward`, key: 'straight_forward' })
        .option({ title: `Be Insecure`, key: 'Insecure' }));


    if (Question.globalAnswers.v1AnnFirstCall === "straight_forward") {
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        mc.talk(`Vanessa gave me your number and said that you are a cute girl and I should give you a call.`, { method: "On Phone" });
        ann.talk(`Oh my God! She always does that!`, { method: "Over Phone" });
        mc.talk(`Sorry, maybe I shouldn't have called?`, { method: "On Phone" });
        ann.talk(`I'm sorry, I didn't mean it in a bad way.`, { method: "Over Phone" });
        ann.talk(`It's just that she always gives my number to random guys.`, { method: "Over Phone" });
        ann.talk(`But wait, did you say that your name is ${mc.name}?`, { method: "Over Phone" });
        mc.talk(`Yes.`, { method: "On Phone" });
        ann.talk(`Oh! You must be Joe's friend!`, { method: "Over Phone" });
        mc.talk(`That's me.`, { method: "On Phone" });
        ann.talk(`I've never met Joe, but I've only heard good things about him.`, { method: "Over Phone" });
        ann.talk(`I also heard Vanessa mentioning your name on one or two occasions.`, { method: "Over Phone" });
        mc.talk(`Yeah? What did she say?`, { method: "On Phone" });
        ann.talk(`Well she didn't know you at the time. But she just said that you are a friend of Joe's, and that you and I have a lot in common.`, { method: "Over Phone" });
        ann.talk(`At least based on what she heard from Joe.`, { method: "Over Phone" });
        mc.talk(`That doesn't sound so bad.`, { method: "On Phone" });
        if (mc.properties.v1Visited != "joe") {

            ann.talk(`Yeah... Hey listen, I am currently studying at the library, and I'm going to be here for quite some time.`, { method: "Over Phone" });
            ann.talk(`So maybe we can talk later?`, { method: "Over Phone" });
            mc.talk(`Sure.`, { method: "On Phone" });
            ann.talk(`Great! Bye for now.`, { method: "Over Phone" });
            ImageClass.setImage(images.v1.RoomAlone_2);
            mc.think(`She said she would be at the library for some time. I should drop by and say hello. I've got nothing to lose.`);
        }


    } else {
        ImageClass.setImage(images.v1.RoomLookingAtPhone);
        mc.talk(`Hey... My name is ${mc.name} you don't know me... I got your number from Vanessa.`, { method: "On Phone" });
        ann.talk(`Hey... How can I help you?`, { method: "Over Phone" });
        mc.talk(`She said I should give you a call, didn't she tell you that?`, { method: "On Phone" });
        ann.talk(`No, she didn't.`, { method: "Over Phone" });
        mc.talk(`Sorry, I didn't mean to disturb you.\nBye.`, { method: "On Phone" });
        ann.talk(`You didn't. I'm currently at the library just reading the same line over and over again.`, { method: "Over Phone" });
        ann.talk(`Wait, did you say that your name is ${mc.name}?`, { method: "Over Phone" });
        mc.talk(`Yeah.`, { method: "On Phone" });
        if (mc.properties.v1Visited != "joe") {

            ann.talk(`I heard your name from Vanessa.`, { method: "Over Phone" });
            mc.talk(`Oh, I hope she said only good things.`, { method: "Over Phone" });
            ann.talk(`Yeah she did.`, { method: "Over Phone" });
            ann.talk(`Hey listen, I am currently studying at the library and I'm going to be here for quite some time.`, { method: "Over Phone" });
            ann.talk(`So maybe we can talk later?`, { method: "Over Phone" });
            mc.talk(`Ok.`, { method: "On Phone" });
            mc.talk(`Great! Bye for now.`, { method: "On Phone" });

            ImageClass.setImage(images.v1.RoomAlone_2);
            mc.think(`That was bad... She must think I'm so insecure after that phone call.`);
            mc.think(`I'm gonna go to the library and prove her wrong.`);
        }
    }


};
export const v1CalledJoe = async () => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingJoey);
    await mc.set((properties) => {
        properties.v1Visited = "joe";
    });
    mc.think(`I'll call Joey.`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    mc.talk(`Hey Joey! What's up?`, { method: "On Phone" });
    joe.talk(`Dude! It's Joe now!`, { method: "Over Phone" });
    mc.talk(`Sorry, it will take me a while to get used to your new name.`, { method: "On Phone" });
    joe.talk(`It's ok dude, what have you been up to?`, { method: "Over Phone" });
    mc.talk(`Nothing really, I thought we could hang out.`, { method: "On Phone" });
    joe.talk(`Sure! Do you have anything in mind?`, { method: "Over Phone" });
    mc.talk(`You're supposed to be the expert.`, { method: "On Phone" });
    joe.talk(`I'm heading to the beach, let's meet up there.`, { method: "Over Phone" });
    mc.talk(`Sure, cya there.`, { method: "On Phone" });
    return jump(v1JoeBeach, "v1JoeBeach");
};

export const v1JoeBeach = async () => {

    ImageClass.setImage(images.v1.BeachMain);
    // <action type="vmod" name="scene1.visitedDay2" do="set" value="1"/>
    mc.think(`I haven't been to the beach in years.`);
    mc.think(`I use to go because my parents made me. We used to bring picnic and just sit for hours at the beach.`);
    mc.think(`Even though I always complained, I used to really have fun when we went, but I never admitted it.`);
    mc.think(`It still looks the same, nothing had changed, except for the people.`);
    mc.think(`And there is Joey sitting right there.`);
    ImageClass.setImage(images.v1.BeachJoe2);
    mc.talk(`Hey Joey!`);
    joe.talk(`It's Joe!`);
    mc.talk(`Yeah yeah, so here we are.`);
    ImageClass.setImage(images.v1.BeachJoe1_Talking1);
    joe.talk(`I thought this would be a good place to talk since we haven't had the chance to really catch up.`);
    joe.talk(`But before all of that, have you called that Ann chick?`);
    ImageClass.setImage(images.v1.BeachJoe1_natural);

    mc.talk(`No... I called you instead.`);
    ImageClass.setImage(images.v1.BeachJoe1_surprise);
    joe.talk(`Why?? You should definitely give her a call man!`);
    ImageClass.setImage(images.v1.BeachJoe1_natural);
    mc.talk(`I will.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
    joe.talk(`I didn't have the chance to really explain what I've been up to.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural);
    mc.talk(`Yeah, you came and left without explaining much.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
    joe.talk(`So listen.`);
    joe.talk(`The Joey you remember is no more. I mean, I'm still me, but I got a confidence boost that you wouldn't believe.`);
    ImageClass.setImage(images.v1.BeachJoe1_Smile1);
    joe.talk(`The girls helped a lot! I am at the point where you can point me to a girl and I'll find my way to her pussy, one way or another.`);
    joe.talk(`So yeah, fuck the old Joey.`);
    joe.talk(`I want you to have the same experience! That's why I want you to give Ann a call!`);
    ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
    joe.talk(`Start with her, and we will have a good time together, trust me.`);
    joe.talk(`Vanessa is the longest one that I've been with lately. But our relationship is special, and kinda refreshing, so I'll keep her around for now.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural);
    mc.talk(`You keep talking about girls, but right now it's only you and I.`);
    mc.talk(`Why don't you show me that Joe magic you keep talking about and get one right now?`);
    ImageClass.setImage(images.v1.BeachJoe1_Natural2);

    joe.talk(`I know most girls that hang around here, they are not worth it believe me.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural);
    mc.talk(`I'll take your word for it on that one.`);


    ImageClass.setImage(images.v1.BeachJoe1_Natural2);


    joe.talk(`You know, I was so caught up with myself that I didn't even ask you.`);


    await joe.setQuestion(new Question({ text: 'Do you want to have this lifestyle at all?', key: `v1EnjoyLifeStyle` })
        .option({ title: `Yes`, key: 'yes' })
        .option({ title: `No`, key: 'no' }));

    if (Question.globalAnswers.v1EnjoyLifeStyle === "yes") {
        mc.talk(`Yes.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`Great! I kept talking about myself and assumed you want the same thing.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Who wouldn't?`);
        ImageClass.setImage(images.v1.BeachJoe1_Smile1);
        joe.talk(`I don't know, but that's an option haha.`);
    } else {
        mc.talk(`No.`);
        joe.talk(`Really? Why not?`);
        mc.talk(`I mean, I do want to change somethings in my life, that's the reason I came here.`);
        mc.talk(`But I'm not sure I want to be like you just yet.\nWe'll see.`);
        joe.talk(`Ok dude, I'll make sure to ask you before doing anything stupid.`);
    }


    return jump(v1JoeBeachQuestions, "v1JoeBeachQuestions");



};

export const v1JoeBeachQuestions = async () => {
    ImageClass.setImage(images.v1.BeachJoe1_natural);
    await mc.setQuestion(new Question({ text: 'There are some things I want to talk to you about.', key: `v1JoeBeachQuestions`, options: { array: "v1JoeBeachQuestionsArr" } })
        .option({ title: `Do you miss your old life?`, key: 'missedOldLife', hide: Question.globalAnswers.v1JoeBeachQuestionsArr?.includes('missedOldLife') })
        .option({ title: `What's your craziest story?`, key: 'craziestStory', hide: Question.globalAnswers.v1JoeBeachQuestionsArr?.includes('craziestStory') })
        .option({ title: `Tell me about Vanessa`, key: 'tellAboutVanessa', hide: Question.globalAnswers.v1JoeBeachQuestionsArr?.includes('tellAboutVanessa') })
        .option({ title: `I saw Vanessa's nudes`, key: 'sawVanNudes', hide: Question.globalAnswers.v1JoeBeachQuestionsArr?.includes('sawVanNudes') || !mc.properties.v1MCSawVanessasBoobsAss })
        .option({ title: `That's all`, key: 'finish' }));

    if (Question.globalAnswers.v1JoeBeachQuestions === "missedOldLife") {
        // mc.properties.v1JoeConversation.push(`missedOldLife`);
        mc.talk(`Do you miss your old life?`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`I can't say I do.`);
        ImageClass.setImage(images.v1.BeachJoe1_surprise);
        joe.talk(`It's true that I barely have time to do the things that I loved doing before.`);
        ImageClass.setImage(images.v1.BeachJoe1_Smile1);
        joe.talk(`But like I already told you, every time I don't feel like going to the gym for example, I remind myself the things I got after I started working out.`);
        mc.talk(`You were a computer geek, no way you don't miss that.`);
        joe.talk(`I can't say that I have zero interest in that anymore, but I found different hobbies now.`);
        mc.talk(`Makes sense.`);
    } else if (Question.globalAnswers.v1JoeBeachQuestions === "craziestStory") {
        // mc.properties.v1JoeConversation.push(`craziestStory`);
        mc.talk(`What's your craziest story?`);
        mc.talk(`You keep telling me about how crazy and amazing your life is now and shit. Come on, give me an example.`);
        ImageClass.setImage(images.v1.BeachJoe1_Natural2);
        joe.talk(`You put me on the spot with that question haha.\nLet me think.`);
        ImageClass.setImage(images.v1.BeachJoe1_Smile1);
        joe.talk(`Oh I got one.`);
        ImageClass.setImage(images.v1.BeachJoe1_Talking1);
        joe.talk(`Ok, so one day I went to the gym minding my own business, doing my usual routine.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`After I was done I went to take a shower.`);
        ImageClass.setImage(images.v1.BeachJoe1_Talking1);
        joe.talk(`I took my clothes off, put them on the nearest shelf and got in.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`I was there for about ten minutes, but when I finished, I saw that someone had stolen my clothes.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Surprise_par);
        joe.talk(`I was sure that it was one of the guys from the gym, you know how guys are. Doing stupid shit.`);
        ImageClass.setImage(images.v1.BeachJoe1_Smile1);
        joe.talk(`So here I was, completely naked, looking for my clothes.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Surprise_par);
        joe.talk(`As I stepped out of the shower area, I felt a girl's hand cover my eyes.`);

        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`Of course I didn't try to resist, who really cares right?`);
        ImageClass.setImage(images.v1.BeachJoe1_Smile1);
        joe.talk(`So, while my eyes are covered I tried to guess who the girl is.`);
        ImageClass.setImage(images.v1.BeachJoe1_surprise);
        joe.talk(`Suddenly, I felt another pair of hands touching my dick.`);
        joe.talk(`The only thing that crossed my mind at that point was: "Please don't be a dude". Luckily she wasn't, I managed to catch a glimpse of a partial face, and confirmed that she was indeed a girl.`);
        ImageClass.setImage(images.v1.BeachJoe1_Talking1);
        joe.talk(`So here I was completely naked, surrounded by two girls in the gym's showers. One girl is kissing my neck, rubbing my body, and the other is sucking me off.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Smiling_par);
        joe.talk(`Needless to say I came in two minutes.`);
        ImageClass.setImage(images.v1.BeachJoe1_Talking1);
        joe.talk(`The girl whose mouth I came in got up and started moving to my side...`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Smiling_par);
        joe.talk(`While that was happening, the hand that was covering my eyes got loose just enough for me to see their mouths kissing and swapping my cum between them...`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Surprise_par);
        joe.talk(`Then they turned me around and ran outside the locker room. I still don't know who they are.`);
        ImageClass.setImage(images.v1.BeachJoe1_Natural2);
        joe.talk(`That's it.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Wow... A story worth telling.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Smiling_par);
        joe.talk(`I know right! Haha.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`You have no idea who are they?`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Surprise_par);
        joe.talk(`I suspected one girl from the gym, but I dropped that idea, she doesn't look like the type.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Oh. Ok.`);
    } else if (Question.globalAnswers.v1JoeBeachQuestions === "tellAboutVanessa") {
        // mc.properties.v1JoeConversation.push(`tellAboutVanessa`);
        mc.talk(`Tell me about Vanessa.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`What do you want to know?`);

        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`What's she like?`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`The best word to describe her is freaky.`);
        ImageClass.setImage(images.v1.BeachJoe1_Natural2);
        joe.talk(`Actually, I met her right here in this spot. She was sitting alone tanning.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`So I walked up to her and talked to her.`);
        if (Question.globalAnswers.V1invitedVanessa) {
            ImageClass.setImage(images.v1.BeachJoe1_Smile1);
            joe.talk(`I would brag like I did back at your place, about how smooth I was.\nBut to be honest it wasn't that hard, she was all over me from the start.`);
        } else {
            ImageClass.setImage(images.v1.BeachJoe1_Smile1);
            joe.talk(`I would brag about how smooth I was.\n But to be honest it wasn't that hard, she was all over me from the start.`);
        }

        ImageClass.setImage(images.v1.BeachJoe1_Natural2);
        joe.talk(`But it's not how we met that's interesting.`);
        ImageClass.setImage(images.v1.BeachJoe1_Talking1);
        joe.talk(`In bed, she is crazy like I've never had before. Even when I think I've seen it all, she keeps surprising me.`);
        joe.talk(`I thought I had been with crazy girls, but Vanessa, she makes those girls look like girl scouts.`);
        joe.talk(`That's the real reason why I keep her around, she gives me what I want.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`So what happens once you get used to it?`);

        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`On to the next one, it's not a big deal.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Ok.`);

    } else if (Question.globalAnswers.v1JoeBeachQuestions === "sawVanNudes") {
        // mc.properties.v1JoeConversation.push(`sawVanNudes`);
        mc.talk(`There's something I wanna tell you.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Smiling_par);
        joe.talk(`Sure, what is it?`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`When you gave me your phone to look at Vanessa's pictures, I swiped the wrong way and I saw some private pictures that she sent you.`);
        ImageClass.setImage(images.v1.BeachJoe1_Talking1);
        joe.talk(`Whatever. Boobs are boobs, ass is ass.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Are you really cool with that?`);

        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
        joe.talk(`It's not like you haven't seen boobs before.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Not my best friend's girlfriend's...`);
        ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Smiling_par);
        joe.talk(`Still, I don't care. If you want to see them again let me know haha.`);
        ImageClass.setImage(images.v1.BeachJoe1_natural);
        mc.talk(`Wow, alright.`);
        mc.think(`How come he doesn't care when someone sees his girl in all of her glory?`);
        mc.think(`I thought I was starting to understand this new Joey, but he was still managing to surprise me.`);
    } else if (Question.globalAnswers.v1JoeBeachQuestions === "finish") {
        mc.talk(`That's about it.`);
        return jump(v1JoeBeachQuestionsAfter, "v1JoeBeachQuestionsAfter");

    }

    return jump(v1JoeBeachQuestions, "v1JoeBeachQuestions");

};
export const v1JoeBeachQuestionsAfter = async () => {

    ImageClass.setImage(images.v1.BeachJoe1_Natural2);
    joe.talk(`Listen, I had this great idea just now while we were talking.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
    joe.talk(`There's this bar I know, it's a great place, in a great location and it's almost always empty.\nTo be honest, I don't even know how they manage to stay open...`);
    ImageClass.setImage(images.v1.BeachJoe1_Smile1);
    joe.talk(`...So anyway!`);
    ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
    joe.talk(`They don't care as long as you look over eighteen, because they're always empty. So you shouldn't have any problem getting in.`);
    ImageClass.setImage(images.v1.BeachJoe1_Smile1);
    joe.talk(`You should take Ann there, I'll text you the address.`);
    if (Question.globalAnswers.V1invitedVanessa) {
        mc.talk(`I kinda got the sense from Vanessa that she isn't the bar type.`);
    } else {
        mc.talk(`You sure? You kinda made it sound like she isn't the bar type.`);
    }

    ImageClass.setImage(images.v1.BeachJoe1_Smile1);
    joe.talk(`Just insist on it and she'll come.`);
    ImageClass.setImage(images.v1.BeachJoe1_Natural2);
    mc.talk(`I'll give it a shot.`);
    ImageClass.setImage(images.v1.BeachJoe1_natural.partials.BeachJoe1_Talking2_par);
    joe.talk(`As usual, don't forget to update me!`);
    ImageClass.setImage(images.v1.BeachJoe1_Natural2);
    mc.talk(`I won't!`);

    return jump(v1AfterMeetings, "v1AfterMeetings");

};


export const v1AnnLibrary = async () => {
    ImageClass.setImage(images.v1.Library1);


    mc.think(`The library... I never thought I would ever come back here after I finished school.`);
    ImageClass.setImage(images.v1.Library2);
    mc.think(`I don't even know what she looks like...`);
    ImageClass.setImage(images.v1.Library3);
    mc.think(`Luckily no one is here except that one girl sitting at the back, it must be her.`);
    ImageClass.setImage(images.v1.Library6);
    mc.talk(`Hey, Ann?`);
    ann.talk(`Yes, that's me.`);
    ImageClass.setImage(images.v1.Library5);
    mc.talk(`Hey, I am ${mc.name}.`);

    ann.talk(`We just spoke on the phone!\nI didn't realize you were coming.`);
    mc.talk(`Is that a bad thing?`);
    ann.talk(`No, not at all.`);
    mc.think(`Fuck, I never asked her what she is doing at the library, I hope she is not underage.`);
    mc.talk(`What are you studying for?`);
    ImageClass.setImage(images.v1.Library4);
    ann.talk(`I'm getting ready for college. I want to get accepted into med school, so I'm studying every chance I get.`);
    mc.think(`Saved!`);
    mc.talk(`Don't you get tired of studying?`);
    ImageClass.setImage(images.v1.Library5);
    ann.talk(`Nope! I like it!`);
    mc.think(`Oh great a bookworm.`);
    ann.talk(`I must admit, it's kinda weird you being here.`);
    mc.talk(`I can leave...`);
    ImageClass.setImage(images.v1.Library4);
    ann.talk(`No, I'm sorry I didn't mean it that way.`);
    ann.talk(`It's just that I almost never meet up with guys, let alone right away.`);
    ann.talk(`Usually we text for a few weeks before we meet.`);
    ImageClass.setImage(images.v1.Library5);
    mc.talk(`A few weeks? Isn't that extreme?`);
    ann.talk(`Maybe, but that's just how I am.`);
    ann.talk(`But with you it's different, since you are a friend of Vanessa's boyfriend.`);
    ann.talk(`So I know you won't try to kidnap me hehe.`);
    mc.talk(`Only if you make me!`);
    ann.talk(`What?`);
    mc.talk(`It was a joke...`);
    ann.talk(`Oh hehe.`);
    ann.talk(`Since you know what I love doing in my free time, which is studying of course.`);


    await ann.setQuestion(new Question({ text: 'I was wondering, what do you do in your free time?', key: `v1AnnAskFreeTime` })
        .option({ title: `Playing PC games`, key: 'playGames' })
        .option({ title: `I like to go out.`, key: 'goingOut' }));

    if (Question.globalAnswers.v1AnnAskFreeTime === "playGames") {
        mc.think(`Better start off on the right foot and tell the truth.`);
        await mc.set((properties) => {
            properties.liar--;
        });
        mc.talk(`I like playing PC games.`);
        ann.talk(`Are you a gamer?`);
        mc.talk(`You could say that.`);
        ann.talk(`A gamer that leaves the house? That's rare!`);
        mc.talk(`I came to the library, so that doesn't count.`);
        ann.talk(`I guess you are right hehe.`);
    }
    if (Question.globalAnswers.v1AnnAskFreeTime === "goingOut") {
        mc.think(`She doesn't know me, so she wouldn't know I'm lying.`);
        mc.talk(`I like to go out.`);
        ann.talk(`Really? Where to?`);
        mc.talk(`All sorts of places... To the beach, to clubs, that sorta thing....`);
        ann.talk(`That's nice, I guess, very different from me.\nI like spending my time here, or at my house watching movies, or just reading.`);
        ann.talk(`Vanessa keeps trying to get me to go out with her, but I keep making up excuses.`);
        mc.talk(`Why? You can try and join her, maybe you would like it.`);
        ann.talk(`I have known her since we were kids, I know how she acts, I would lose myself.`);
        ann.talk(`But lately I've been thinking that I should try and get out of my comfort zone.`);
        mc.talk(`Since you already did something that you never do, by inviting me here, maybe you can make it a double.`);
        mc.talk(`I was thinking... Maybe you can join me.`);
        ann.talk(`Join you? You mean like... a date? I don't know...`);
        mc.talk(`Not a date, just two people trying to get out of their comfort zones together!`);
        ann.talk(`But... you said... you said that you like to go out!`);
        mc.talk(`Oh... Yeah... I'm a party animal!\nYou should see my moves.`);
        ann.talk(`Hehe, you know what? I should get out of my comfort zone.\nI'll join you. What's there to lose, right?`);
        mc.talk(`What, really?\nI mean cool!`);
        ann.talk(`See you tonight!`);
        mc.think(`I can't believe that just worked.`);
        mc.talk(`Great!`);
    }

    if (Question.globalAnswers.V1AreYouSeeingAnyone === false) {

        mc.talk(`Vanessa mentioned that you are not the social type. So I guess you don't have Facebook or Insta.`);
    } else {

        mc.talk(`Before I go, do you have Facebook or Insta?`);
    }

    ImageClass.setImage(images.v1.Library4);
    ann.talk(`I don't like social media that much... It feels fake, people add you and then ignore you in real life.`);
    ann.talk(`I had Facebook before, but I closed it.`);
    mc.talk(`If you reopen it let me know, so I'll add you.`);
    ImageClass.setImage(images.v1.Library5);
    ann.talk(`Ok I'll do that!`);

    mc.talk(`So, I don't want to take anymore of your time, I just wanted to stop by and say hi.`);
    ImageClass.setImage(images.v1.Library6);
    ann.talk(`That's nice hehe, I'll continue studying.`);
    mc.talk(`Bye Ann.`);
    return jump(v1AfterMeetings, "v1AfterMeetings");
};

export const v1AfterMeetings = async () => {

    if (!Game.seenScenarios.includes(`v1AfterMeetings`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 11;
            properties.instaFollowers = 57;
        });
    }
    ImageClass.setImage(images.v1.RoomComputerAlone);
    mc.think(`Finally, home!`);
    mc.think(`I have some time to kill, let's see what's new on Insta.`);

    await Insta.open(getInstaData());


    return jump(v1AfterMeetings2, "v1AfterMeetings2");

};

export const v1AfterMeetings2 = async () => {
    ImageClass.setImage(images.v1.RoomComputerScreenCloseOn);

    if (!mc.properties.sawAlex) {
        mc.think(`I've never seen her before! She is still new, only two photos.`);
        mc.think(`I bet she'll get more popular soon; she really has potential.`);
    } else if (getAlexImagesPost(2)?.mcSeen) {
        mc.think(`Alex uploaded another photo! Nice, I'm always happy to see more of those.`);
        mc.think(`I wonder what else she's hiding, besides that tattoo.`);
        mc.think(`I should remember to check her page every now and then.`);
    }


    if (mc.properties.v1Visited == "joe") {
        await mc.think(`Just in time!`);
        if (!empty.properties.tempBool) {
            await empty.set((properties) => {
                properties.tempBool = true;
            });
            global.toast?.show(`You got the bar address from Joey.`);
        }
        mc.think(`Joey texted me the bar address.`);
        mc.think(`I have everything I need to call Ann. But I don't know anything about her.`);
        mc.think(`Still, now's not the time for me to pussy out.`);
        ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
        mc.think(`I need to stop overthinking it and just call her.`);
        await v1CalledAnn();
        mc.talk(`So, I was thinking... Do you want to meet up somewhere?`, { method: "On Phone" });
        ann.talk(`I usually don't do this, but I'm so tired after studying all day... So why not?`, { method: "Over Phone" });
        mc.talk(`Joey just gave me an address for a bar he knows, I thought about checking it out, would you like to join me?`, { method: "On Phone" });
        ann.talk(`A bar? I don't know... I don't drink so I'd have nothing to do there.`, { method: "Over Phone" });
        mc.talk(`You can order water or something, it's just to sit and talk.`, { method: "On Phone" });
        ann.talk(`Are you sure that's what you want to do?`, { method: "Over Phone" });
        mc.talk(`Yeah I think it's going to be fun.`, { method: "On Phone" });
        ann.talk(`Well... I guess I can try, what's the worst that can happen right?`, { method: "Over Phone" });
        mc.talk(`Great!\nI'll text you the address.`, { method: "On Phone" });
        ann.talk(`Ok. I'll see you there in a few.`, { method: "Over Phone" });
        ImageClass.setImage(images.v1.RoomLookingAtPhone);
        mc.think(`I texted her the address. Let's go and meet her.`);
    } else {

        if (Question.globalAnswers.v1AnnAskFreeTime === "goingOut") {
            ImageClass.setImage(images.v1.RoomComputerScreenCloseOn);
            mc.think(`Enough about her.`);
            mc.think(`I told Ann that I know places, but I really don't.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone);
            mc.think(`I need to find a good place to take her to.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingJoey);
            mc.think(`I should ask Joey.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            mc.talk(`Hey Joey.`, { method: "On Phone" });
            joe.talk(`Hey ${mc.name}.`, { method: "Over Phone" });
            mc.talk(`I was wondering if you know a good place that I can take Ann to.`, { method: "On Phone" });
            joe.talk(`SWEET! So you got a date!`, { method: "Over Phone" });
            mc.talk(`It's not really a date, just hanging out.`, { method: "On Phone" });
            joe.talk(`Of course dude, there's this bar. You can take Ann there, the place is really empty most of the time and they don't ask for ID as long as you are above eighteen.`, { method: "Over Phone" });
            joe.talk(`I'll text you the address.`, { method: "Over Phone" });
            mc.talk(`Thanks man.`, { method: "On Phone" });
            joe.talk(`Don't forget to tell me how it went!`, { method: "Over Phone" });
            await mc.talk(`I will, cya.`, { method: "On Phone" });
            if (!empty.properties.tempBool) {
                await empty.set((properties) => {
                    properties.tempBool = true;
                });
                global.toast?.show(`You got a text from Joe.`);
            }
            ImageClass.setImage(images.v1.RoomLookingAtPhone);
            mc.think(`Great, Joey texted me the address of the bar.`);
            mc.think(`I can invite Ann there now.`);

        } else {
            ImageClass.setImage(images.v1.RoomLookingAtPhone);
            mc.think(`It took me some time to get home. Plus, I've checked Insta.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingJoey);
            mc.think(`Maybe Joey has an idea for someplace I can take Ann tonight.\nThat's if she agrees to join me.`);
            ImageClass.setImage(images.v1.RoomLookingAtPhone2);
            mc.talk(`Hey Joe.`, { method: "On Phone" });
            joe.talk(`Hey ${mc.name}.`, { method: "Over Phone" });
            mc.talk(`I was wondering, do you know a good place that I can take Ann to?`, { method: "On Phone" });
            joe.talk(`SWEET! So you got a date!`, { method: "Over Phone" });
            mc.talk(`I didn't ask her out yet.`, { method: "On Phone" });
            joe.talk(`Oh, I got it.`, { method: "Over Phone" });
            joe.talk(`There is a bar I know.`, { method: "Over Phone" });
            joe.talk(`You can take her there, the place is really empty most of the time and they don't ask for ID as long as you are above eighteen.`, { method: "Over Phone" });
            joe.talk(`I'll text you the address.`, { method: "Over Phone" });
            mc.talk(`Thanks man.`, { method: "On Phone" });
            joe.talk(`Don't forget to tell me how it went!`, { method: "Over Phone" });
            await mc.talk(`I won't, see ya.`, { method: "On Phone" });
            if (!empty.properties.tempBool) {
                await empty.set((properties) => {
                    properties.tempBool = true;
                });
                global.toast?.show(`You got a text from Joe.`);
            }
            ImageClass.setImage(images.v1.RoomLookingAtPhone);
            mc.think(`Great, Joey texted me the address of the bar.`);
            mc.think(`I can invite Ann there now.`);


        }
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        mc.talk(`Hey Ann it's ${mc.name}.`, { method: "On Phone" });
        ann.talk(`Oh! Hey!`, { method: "Over Phone" });
        mc.think(`She sounds excited.`);


        if (Question.globalAnswers.v1AnnAskFreeTime === "goingOut") {
            mc.talk(`So you said you wanted to join me today. There's this bar I know, kind of quiet spot, wanna check it out?`, { method: "On Phone" });
            ann.talk(`Hmm a bar? I don't know...`, { method: "Over Phone" });
            mc.talk(`Come on it will be fun!`, { method: "On Phone" });
            ann.talk(`Ok ok! Send me the address and I'll meet you there.`, { method: "Over Phone" });
            mc.talk(`Cya in a bit!`, { method: "On Phone" });
            ImageClass.setImage(images.v1.RoomLookingAtPhone);
            mc.think(`Ok I texted her the address. I'll go and meet her there.`);
        } else {
            mc.talk(`Are you busy tonight?`, { method: "On Phone" });
            ann.talk(`I've been studying all day so no, I don't have any plans, why do you ask?`, { method: "Over Phone" });
            mc.talk(`Joey just texted me the address for a bar he knows. I was thinking of checking it out, would you like to join me?`, { method: "On Phone" });
            ann.talk(`Bar? I don't know... I don't drink so I'd have nothing to do there.`, { method: "Over Phone" });
            ann.talk(`And why would you wanna go there anyway? I thought you weren't the bar type.`, { method: "Over Phone" });
            mc.talk(`I'm not, but lately I've been thinking about changing my usual hobbies...`, { method: "On Phone" });
            mc.talk(`I believe that you are the best person to share that experience with me.`, { method: "On Phone" });
            mc.talk(`So, what do you say?`, { method: "On Phone" });
            ann.talk(`Well...`, { method: "Over Phone" });
            ann.talk(`When you put it that way, it's hard to refuse.`, { method: "Over Phone" });
            mc.talk(`Is that a yes?`, { method: "On Phone" });
            ann.talk(`I guess I can try, what's the worst that can happen right?`, { method: "Over Phone" });
            mc.talk(`Great!\nI'll text you the address.`, { method: "On Phone" });
            ann.talk(`Ok. I'll see you there in a few.`, { method: "Over Phone" });

            ImageClass.setImage(images.v1.RoomLookingAtPhone);
            mc.think(`Ok I texted her the address, time to go and meet her there.`);
        }
    }

    return jump(v1AfterAnnsCall, "v1AfterAnnsCall");
};


export const v1AfterAnnsCall = async () => {
    ImageClass.setImage(images.v1.RoomLookingAtPhoneUnknown);

    mc.think(`Someone is calling.`);
    mc.think(`Unknown number?`);
    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    mc.talk(`Hello?`, { method: "On Phone" });
    vanessa.talk(`Hey ${mc.name}. It's Vanessa.`, { method: "Over Phone" });
    if (mc.properties.metVanessa) {
        mc.think(`Joey's girlfriend?\nWeird, why is she calling me?`);
    } else {
        mc.think(`Why is Joey's girlfriend calling me? Weird.`);
    }

    mc.talk(`Yes?`, { method: "On Phone" });
    vanessa.talk(`What are you doing right now?`, { method: "Over Phone" });
    mc.talk(`I was about to go and meet Ann.`, { method: "On Phone" });
    vanessa.talk(`OHHH nice! Very nice! But listen, ditch her. I need to talk to you, meet me instead of her.`, { method: "Over Phone" });
    mc.talk(`What about Joe? Is he coming?`, { method: "On Phone" });
    vanessa.talk(`No, just me and you.`, { method: "Over Phone" });
    mc.think(`I wonder what she wants.`);
    mc.talk(`Can you tell me what's it about?`, { method: "On Phone" });
    vanessa.talk(`You will have to meet me to find out.`, { method: "Over Phone" });

    await vanessa.setQuestion(new Question({ text: 'So, what do you say?', options: { method: "On Phone" }, key: `v1WentToTheBarWith` })
        .option({ title: `Go to the bar with Vanessa`, key: 'vanessa' })
        .option({ title: `Go to the bar with Ann`, key: 'ann' }));

    ImageClass.setImage(images.v1.RoomLookingAtPhone2);
    if (Question.globalAnswers.v1WentToTheBarWith == "vanessa") {

        mc.talk(`Sure, I'll cancel on her, and let's meet up there.`, { method: "On Phone" });
        vanessa.talk(`GREAT! Text me the address.`, { method: "Over Phone" });
        mc.talk(`Alright, cya.`, { method: "On Phone" });
        ImageClass.setImage(images.v1.RoomLookingAtPhone);
        mc.think(`I texted Vanessa the bar's address.`);
        ImageClass.setImage(images.v1.RoomLookingAtPhoneCallingAnn);
        mc.think(`Now I just need to cancel with Ann.`);
        ImageClass.setImage(images.v1.RoomLookingAtPhone2);
        mc.talk(`Hey Ann.`, { method: "On Phone" });


        ann.talk(`Hey ${mc.name}! I am all dressed up and getting ready to head out!`, { method: "Over Phone" });
        mc.talk(`Sorry, something came up and I need to cancel.`, { method: "On Phone" });
        ann.talk(`Why? What happened? Was it something I said?`, { method: "Over Phone" });
        mc.talk(`No, not at all, it's something personal.`, { method: "On Phone" });
        ann.talk(`Oh... Ok... Have a good night.`, { method: "Over Phone" });


        ImageClass.setImage(images.v1.RoomLookingAtPhone);
        mc.think(`She hung up.`);
        mc.think(`Damn she sounded upset... I hope I didn't fuck up.`);
        mc.think(`Anyway, I made my choice, time to meet Vanessa at the bar.`);
        return jump(v1VanessaBarMeeting, "v1VanessaBarMeeting");
    }

    mc.talk(`Sorry Vanessa I already made plans with Ann.`, { method: "On Phone" });
    vanessa.talk(`So what?`, { method: "Over Phone" });
    mc.talk(`I can't just cancel.`, { method: "On Phone" });
    mc.talk(`Besides, you are the one who introduced her to me so, don't you want it to work?`, { method: "On Phone" });
    vanessa.talk(`Alright have fun.`, { method: "Over Phone" });
    vanessa.talk(`Bye.`, { method: "Over Phone" });
    ImageClass.setImage(images.v1.RoomLookingAtPhone);
    mc.think(`She hung up.`);
    mc.think(`I am so curious about what she might have wanted, but I already made plans with Ann, I couldn't just cancel.`);
    mc.think(`Anyway, I made my choice, time to meet Ann at the bar.`);
    return jump(v1AnnBarMeeting, "v1AnnBarMeeting");

};

export const v1AfterDates = async () => {

    ImageClass.setImage(images.v1.RoomComputerAlone);

    mc.think(`I barely touched my computer these past few days, but I can't say it hasn't been nice going out and meeting new people.`);
    if (Question.globalAnswers.v1WentToTheBarWith === "vanessa") {
        mc.think(`I still have no idea what to make of Vanessa, she seems like she likes Joey.`);
        mc.think(`But on the other hand, she did stay with that bartender... Maybe I should go there tomorrow and have a talk with him, just to make sure nothing is going on...`);
        mc.think(`I just hope he will tell the truth.`);
        mc.think(`She did go out of her way to meet with me because I'm Joey's best friend; it seems like she was doing it for him.`);
        mc.think(`I wonder what she will get him for his birthday.`);
        if (Question.globalAnswers.v1JoePresentIdea === "sextape") {
            mc.think(`I can't believe she actually thinks making a sex tape for his birthday is a good idea.`);
            mc.think(`Maybe Joey will show me, haha. But who wants to see his dick anyway?`);
        }

        mc.think(`I feel bad for bailing on Ann, I hope she can forgive me. I'll need to make it up to her.`);
    } else {
        mc.think(`Meeting up with Ann didn't go so bad.`);
        mc.think(`She's kinda cute.`);
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            mc.think(`The way she gave the bartender her number just shows how naive she really is.`);
            mc.think(`And thanks to that, I guess I have some competition.`);
            mc.think(`He did ask for my permission to get her number though.\nI could have said no, so I can't really complain.`);
        }

    }




    return jump(v1BeforeEnding, "v1BeforeEnding");

};
export const v1BeforeEnding = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`v1BeforeEnding`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 11;
            properties.instaFollowers = 170;
        });
    }
    await UI.add({
        key: "v1FirstInstaOpen",
        btns:
            [
                { image: uiImages.pc, key: "insta", tooltip: "Check Insta" },
                { image: uiImages.continue, key: "continue", tooltip: "Continue" }
            ]
    });
    if (UI._globalUI.v1FirstInstaOpen === "insta") {
        mc.think(`Before I go to sleep, let's see what's going on with Alex.`);
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v1FirstInstaOpen === "continue") {
        return jump(v1Finish, "v1Finish");

    }
    return jump(v1BeforeEnding, "v1BeforeEnding");
};

export const v1Finish = async () => {
    return jump(AfterBarAtHome, "AfterBarAtHome");

};
